export default __webpack_public_path__ + "static/media/AMS Master History_Dark2.fa3c0266.svg";